<template>
  <div class="MultiContentModal">
    <el-dialog
      title=""
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="handleOpen"
      width="30%"
    >
      <div class="contentPanel">
        <div
          class="contentBox"
          v-for="(item, index) in inputItems"
          :key="item.id"
        >
          <div class="contentRow">
            <div
              v-if="item.contentPattern == 'audioText'"
              class="materialCardText"
            >
              <audio
                v-if="item.lessonContentTemplate.material.materialUrl"
                :src="item.lessonContentTemplate.material.materialUrl"
                :loop="false"
                controls
                preload="auto"
                controlsList="nodownload noplaybackrate"
              ></audio>
              <p style="padding: 10px">
                {{ item.lessonContentTemplate.material.displayAudioText }}
              </p>
            </div>

            <img
              v-if="item.contentPattern == 'image'"
              class="materialCardImage"
              :src="item.lessonContentTemplate.material.materialUrl"
            />

            <audio
              v-if="item.contentPattern == 'audio'"
              class="materialCardAudio"
              :src="item.lessonContentTemplate.material.materialUrl"
              :loop="false"
              controls
              preload="auto"
              controlsList="nodownload noplaybackrate"
            ></audio>

            <y-j-video
              v-if="item.contentPattern == 'video'"
              class="materialCardVideo"
              :src="item.lessonContentTemplate.material.materialUrl"
            />
            <div class="contentOpration">
              <div class="contentOprationItem" @click="handleEdit(index)">
                编辑
              </div>
              <div class="contentOprationItem" @click="handleDelete(index)">
                删除
              </div>
            </div>
          </div>

          <el-button class="addButton" @click="handleAddAfter(index)"
            >在下方添加</el-button
          >
        </div>
        <el-button
          v-if="inputItems.length == 0"
          class="addButton"
          @click="handleAdd"
          >在下方添加</el-button
        >
      </div>
      <div class="footer">
        <el-button style="width: 80px" type="primary" @click="handleConfirm"
          >确定
        </el-button>
      </div>
    </el-dialog>
    <ContentPickModal
      v-if="visible"
      :materialInfo="materialInfo"
      @refreshMaterial="refreshMaterial"
    ></ContentPickModal>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ContentPickModal from "./ContentPickModal.vue";
import YJVideo from "@/components/video/index.vue";

export default {
  name: "MultiContentModal",
  components: {YJVideo, ContentPickModal },
  props: {
    inputValArr: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      editIndex: -1,
      editMode: "add",
      materialInfo: null,
      inputItems: [],
    };
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.courseCenter.multiContentModalVisible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "multiContentModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    handleOpen() {
      this.inputItems = JSON.parse(JSON.stringify(this.inputValArr));
      console.log(this.inputItems);
    },
    refreshMaterial(material) {
      console.log(material);
      if (this.editMode == "add") {
        this.inputItems.push(material);
      } else if (this.editMode == "addAfter") {
        this.inputItems.splice(this.editIndex + 1, 0, material);
      } else if (this.editMode == "edit") {
        this.inputItems.splice(this.editIndex, 1, material);
      }
    },
    handleConfirm() {
      this.$emit("refreshInputVal", this.inputItems);
      this.setData({ key: "multiContentModalVisible", value: false });
    },
    handleAdd() {
      this.materialInfo = null;
      this.editMode = "add";
      this.setData({ key: "contentPickModalVisible", value: true });
    },
    handleAddAfter(index) {
      this.materialInfo = null;
      this.editIndex = index;
      this.editMode = "addAfter";
      this.setData({ key: "contentPickModalVisible", value: true });
    },
    handleDelete(index) {
      this.$confirm("确定要删除此条内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.inputItems.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功",
          });
        })
        .catch(() => {});
    },
    handleEdit(index) {
      this.editMode = "edit";
      this.materialInfo = this.inputItems[index];
      this.editIndex = index;
      this.setData({ key: "contentPickModalVisible", value: true });
    },
  },
};
</script>

<style lang="scss" scoped>
//.MultiContentModal {
::v-deep .el-dialog {
  min-width: 680px;
  min-height: 650px;
  position: relative;
  margin-top: 5vh !important;

  .el-dialog__header {
    box-shadow: none;
  }
}

.contentPanel {
  padding: 10px;
  height: 500px;
  font-size: 16px;
  background: #fafafa;
  letter-spacing: 0.1em;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;

  .contentBox {
    display: flex;
    flex-direction: column;
    align-items: center;

    .contentRow {
      display: flex;
      flex-direction: row;
      .contentOpration {
        width: 40px;

        .contentOprationItem {
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: solid 1px #999;
        }

        .contentOprationItem:hover {
          background-color: aliceblue;
          cursor: pointer;
        }
      }
    }

    .el-dropdown-link {
      cursor: pointer;
      color: #10689c;
    }
  }
}

.addButton {
  height: 36px;
  width: 400px;
}

.footer {
  position: absolute;
  text-align: center;
  bottom: 20px;
  right: 50px;
}

.materialCardText {
  border: solid 1px #999;
  width: 360px;
}
.materialCardImage {
  border: solid 1px #999;
  width: 360px;
}
.materialCardAudio {
  border: solid 1px #999;
  width: 360px;
}
.materialCardVideo {
  border: solid 1px #999;
  width: 360px;
}
//}
</style>
